import styled from "@emotion/styled";

// This panel is shown in two very different places — the login page's dark left
// panel and the landing page's light card — so it inherits its colour from the
// parent rather than picking one.
export const NoPermissionContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    width: 100%;
    max-width: 320px;
    color: inherit;
`;

export const NoPermissionTitle = styled.h2`
    margin: 0;
    font-size: 1.4rem;
`;

export const NoPermissionMessage = styled.p`
    margin: 0;
    font-size: 0.9rem;
    opacity: 0.85;
`;

export const NoPermissionButton = styled.button`
    width: 100%;
    margin-top: 0.5rem;
    padding: 0.75rem 1rem;
    border-radius: 0.375rem;
    border: 1px solid #d8c0c0;
    background-color: #ffffff;
    color: #000000;
    cursor: pointer;
    font-family: Helvetica, Arial, sans-serif;

    &:hover {
        background-color: rgb(22 59 93);
        color: #ffffff;
        border-color: rgb(22 59 93);
    }
`;
